<template>
  <section class="classes" id="classes">
    <div class="container classes-inner">
      <!-- Left Column: Image -->
      <div class="classes-img wow slideInLeft">
        <img src="@/assets/images/diamond_gym_horne_poschodie.jpg" alt="Možnosti u nás" />
      </div>

      <!-- Right Column: Text & Items -->
      <div class="classes-text wow slideInRight">
        <h2>Možnosti u nás</h2>
        <p>
          Začnite cvičiť dnes a dosiahnite svoje ciele s našou pomocou! Nech už chcete zlepšiť kondíciu,
          schudnúť alebo posilniť sa, sme tu pre vás na každom kroku.
        </p>
        <div class="class-items">
          <div class="item wow fadeInUp" data-wow-delay="0.1s">
            <div class="item-icon">
              <i class="fa fa-bolt"></i>
            </div>
            <div class="item-text">
              <h4>Tréning</h4>
              <p>Dosiahnite svoje ciele vďaka nášmu skvelému tréningu a profesionálnemu vedeniu.</p>
            </div>
          </div>
          <div class="item wow fadeInUp" data-wow-delay="0.2s">
            <div class="item-icon">
              <i class="fa fa-heart"></i>
            </div>
            <div class="item-text">
              <h4>Masáže</h4>
              <p>
                Naše masáže vám poskytnú úžasný relaxačný zážitok a pomôžu vám obnoviť sa po náročnom tréningu.
                <strong class="unavailable">MOMENTÁLNE NEDOSTUPNÉ</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.classes {
  background-color: #111;
}

.classes-inner {
  display: flex;
  gap: 40px;
  align-items: center;
}

/* Image column */
.classes-img {
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
  transition: box-shadow 0.3s ease;
}

.classes-img:hover {
  box-shadow: 0 8px 32px rgba(232, 185, 35, 0.2);
}

.classes-img img {
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.classes-img:hover img {
  transform: scale(1.03);
}

/* Text column */
.classes-text {
  flex: 1;
  background-color: #1a1a1a;
  border-radius: 12px;
  padding: 36px 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.classes-text h2 {
  font-size: clamp(24px, 3.5vw, 34px);
  color: #E8B923;
  margin-bottom: 12px;
}

.classes-text h2::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  background: #E8B923;
  border-radius: 2px;
  margin-top: 10px;
}

.classes-text > p {
  font-size: 15px;
  line-height: 1.75;
  color: #bbb;
  margin-top: 16px;
}

/* Class items */
.class-items {
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.item {
  display: flex;
  gap: 18px;
  align-items: flex-start;
  background: #222;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid transparent;
  transition: border-color 0.25s ease, background-color 0.25s ease;
}

.item:hover {
  background: #272727;
  border-color: rgba(232, 185, 35, 0.25);
}

.item-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: rgba(232, 185, 35, 0.12);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #E8B923;
  font-size: 18px;
}

.item-text h4 {
  font-size: 16px;
  color: #E8B923;
  margin-bottom: 6px;
}

.item-text p {
  font-size: 14px;
  line-height: 1.65;
  color: #aaa;
}

.unavailable {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: #e87923;
  letter-spacing: 0.04em;
}

/* Responsive */
@media (max-width: 860px) {
  .classes-inner {
    flex-direction: column;
    gap: 24px;
  }

  .classes-img {
    width: 100%;
  }

  .classes-img img {
    aspect-ratio: 16 / 9;
  }

  .classes-text {
    width: 100%;
    padding: 24px 20px;
  }
}

@media (max-width: 480px) {
  .classes-text {
    padding: 20px 16px;
  }

  .item {
    padding: 14px;
  }

  .item-icon {
    width: 38px;
    height: 38px;
    font-size: 16px;
  }
}
</style>
